import { IonIcon } from '@ionic/react';
import { closeOutline } from 'ionicons/icons';
import React from 'react';
import { useCanvas } from './CanvasContext';
import './Canvas.scss';

/**
 * Home plus one tab per open canvas. Hidden entirely until something is open,
 * so the homepage looks unchanged until a canvas is actually needed.
 */
export const CanvasTabs: React.FC = () => {
  const canvas = useCanvas();
  if (!canvas || canvas.tabs.length === 0) return null;

  const { tabs, activeId, openCanvas, closeCanvas, showHome } = canvas;

  return (
    <div className="canvas-tabs" role="tablist">
      <button
        type="button"
        role="tab"
        aria-selected={activeId === null}
        className={`canvas-tab-label${activeId === null ? ' is-active' : ''}`}
        onClick={showHome}
      >
        Home
      </button>

      {tabs.map((tab) => (
        <span
          key={tab.id}
          className={`canvas-tab${activeId === tab.id ? ' is-active' : ''}`}
        >
          <button
            type="button"
            role="tab"
            aria-selected={activeId === tab.id}
            className="canvas-tab-label"
            onClick={() => openCanvas(tab)}
          >
            {tab.title}
          </button>
          <button
            type="button"
            className="canvas-tab-close"
            aria-label={`Close ${tab.title}`}
            onClick={() => closeCanvas(tab.id)}
          >
            <IonIcon icon={closeOutline} />
          </button>
        </span>
      ))}
    </div>
  );
};

export default CanvasTabs;
